@if (notifications.length > 0) {
  <div class="global-notification-overlay" role="region" aria-label="System notifications">
    @for (notification of notifications; track notification.id) {
      <div
        class="global-notification"
        [class.global-notification--warning]="notification.urgency === 'WARNING'"
        [class.global-notification--alert]="notification.urgency === 'ALERT'"
        role="alert"
      >
        <i
          class="pi notification-icon"
          [class.pi-info-circle]="notification.urgency === 'INFO'"
          [class.pi-exclamation-triangle]="notification.urgency === 'WARNING'"
          [class.pi-exclamation-circle]="notification.urgency === 'ALERT'"
          aria-hidden="true"
        ></i>
        <div class="notification-content">
          <strong>{{ notification.title }}</strong>
          <p>{{ notification.message }}</p>
        </div>
        <button type="button" class="notification-close" aria-label="Close notification" (click)="dismiss(notification)">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
}

